import React, { useEffect, useRef, useState } from 'react';
import { SketchPicker } from 'react-color';
import styled from 'styled-components';
import editIcon from "../../../Assets/edit.svg";



const ThemeMain = styled.div`
display: flex;
border-radius: .5rem;
    border: 1px solid #d1d5db;
`;
const ThemeInput = styled.input`
    border-radius: .5rem;
    padding-right: .75rem;
    padding-left: 1rem;
    padding-bottom: .3rem;
    padding-top: .3rem;
    width:100%;
    outline-width: 0;
    border: 1px;
    .active {
     border-radius: 0;
      outline-width: 0;
    }
     .focus {
     border-radius: 0;
      outline-width: 0;
     }
`;

const ThemeColorPicker = ({ value, onChange, name }) => {
  const generateUniqueId = () => `color-picker-${Math.random().toString(36).substr(2, 9)}`;

  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const colorPickerRef = useRef(null);

  const handleOutsideClick = (event) => {
    if (colorPickerRef.current && !colorPickerRef?.current.contains(event.target)) {
      setDisplayColorPicker(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  };

  const handleChange = (newColor) => {
    onChange?.(newColor.hex);
  };

  const onInputChange = (event) => {
    const inputValue = event.target.value;
    onChange?.(inputValue.charAt(0) === '#' ? inputValue : `#${inputValue}`);
  };

  const uniqueId = useRef(generateUniqueId());

  const ThemeColor = styled.div`
  cursor: pointer;
  background-color: ${value};
  border-radius: .4rem 0 0 .4rem;
  border-right: 1px solid#d1d5db;
      padding: 7px;
    display: flex;
    align-items: center;
`;

  return (
    <div className={`${uniqueId.current}`}>
      <ThemeMain>
      <ThemeColor  onClick={handleClick}> <img src={editIcon} alt="edit" height={'16px'} width={'16px'}/></ThemeColor>
        <ThemeInput
          value={value}
          onChange={onInputChange}
        />
       
      </ThemeMain>
      {displayColorPicker && (
        <div style={{ position: 'absolute', zIndex: '2', marginTop: '10px' }} ref={colorPickerRef}>
          <SketchPicker
            color={value}
            onChange={handleChange}
          />
        </div>
      )}
    </div>
  );
};

export default ThemeColorPicker;


